import React from 'react';

import { tabChange } from '../uiFunctions/uiActions';

export class ActionTabs extends React.Component {
	render() {
		const handleAdd = this.props.handleAdd;
		const handleSave = this.props.handleSave;
		const handleDelete = this.props.handleDelete;
		const tabs = this.props.tabs
		const id = this.props.id;
		// console.log(tabs);

		return (
			<React.Fragment>
				<div id={id+"-tabs-wrapper"} className="tabs-wrapper">
					<div id={id+"-tabs"} className="tabs">
						{(tabs) && (
							tabs.map((tab, index) =>
								<React.Fragment key={(tab.id || index)}>
									<div id={"tab-"+(tab.id || index)}
										className={"tab "+id+"-"+(tab.id || index)}
										onClick={() => tabChange(id, (tab.id || index))} >
											{tab.name}
									</div>
								</React.Fragment>
							)
						)}
					</div>
					<div className="tab-group" >
						{(handleAdd) && (
							<div className={"tab-action add"} onClick={() => handleAdd()}><i className="fas fa-plus"></i></div>
						)}
						{(handleSave) && (
							<div className={"tab-action save"} onClick={() => handleSave()}><i className="far fa-save"></i></div>
						)}
						{(handleDelete) && (
							<div className={"tab-action delete"} onClick={() => handleDelete()}><i className="far fa-trash-alt"></i></div>
						)}
					</div>
				</div>
			</React.Fragment>
		)
	}
}


// WEBPACK FOOTER //
// ./src/helpers/uiComponents/ActionTabs.js